import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createSlots as _createSlots, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "q-mx-sm q-mb-sm" }
const _hoisted_2 = {
  class: "tree-selection",
  ref: "treeSelection"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Организация")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-negative" }, "Укажите ветвь структуры", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Структура не выстроена...")
const _hoisted_6 = {
  key: 0,
  class: "row items-center q-mt-xs"
}
const _hoisted_7 = {
  class: "ellipsis",
  style: {"max-width":"130px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "tab-header q-ml-sm" }, "Сотрудники", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "patients-tab-header tab-header" }, [
  /*#__PURE__*/_createTextVNode("АКТУАЛЬНЫЕ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ПАЦИЕНТЫ")
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Добро пожаловать в ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "SmartPro", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("!")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Это облегченная мобильная версия знакомой вам ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "MedsafePro", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "SmartPro", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" служит для быстрого создания индивидуальных направлений ")
const _hoisted_22 = { class: "row" }
const _hoisted_23 = {
  key: 0,
  class: "column q-mt-xs"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("ФИО")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("День рождения")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Пол")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Подразделение / Должность")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Визит")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Статус")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Контракт")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Тип контракта")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Тип осмотра")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Тип оплаты")
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "small-note" }, "Продолжить", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "small-note" }, "Удалить", -1)
const _hoisted_37 = { class: "q-mb-none" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "Док-ты:", -1)
const _hoisted_39 = { class: "q-mb-none" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" В работе: ")
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "column" }
const _hoisted_44 = { class: "text-center q-my-md" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-pa-md" }, "Черновики", -1)
const _hoisted_46 = {
  class: "ellipsis",
  style: {"max-width":"80px"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "small-note" }, "Продолжить", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "q-ml-xs" }, "Перевести", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "q-ml-xs" }, "Копировать", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Направление еще не готово..."),
  /*#__PURE__*/_createElementVNode("div", null, "Обычно, создание занимает до минуты."),
  /*#__PURE__*/_createElementVNode("div", null, "Данные обновлены, попробуйте снова")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-pa-sm" }, "Памятка к договору", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle2" }, "Администраторам", -1)
const _hoisted_53 = { class: "q-pa-sm" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle2" }, "Тип МО", -1)
const _hoisted_55 = { class: "q-pa-sm" }
const _hoisted_56 = { class: "q-pa-sm column" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "text-h6" }, "Стучалка", -1)
const _hoisted_58 = { class: "text-subtitle2" }
const _hoisted_59 = { class: "text-subtitle2" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Баланс: ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_spinner_hourglass = _resolveComponent("q-spinner-hourglass")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_SlideOption = _resolveComponent("SlideOption")!
  const _component_q_virtual_scroll = _resolveComponent("q-virtual-scroll")!
  const _component_q_pull_to_refresh = _resolveComponent("q-pull-to-refresh")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_infinite_scroll = _resolveComponent("q-infinite-scroll")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_q_list, {
        padding: "",
        class: "rounded-borders q-px-xs q-py-none expandable-filters q-mb-xs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_expansion_item, {
            modelValue: _ctx.data.expandedOrgSelector,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.expandedOrgSelector) = $event)),
            dense: "",
            "dense-toggle": "",
            "expand-separator": "",
            class: "q-px-none",
            label: _ctx.orgLabel,
            "header-class": 
            !_ctx.orgProcessing
            && (_ctx.orgLabel === 'Организация не выбрана' || _ctx.orgLabel === 'Нет доступных организаций')
            ? 'text-negative' : 'text-primary',
            disable: 
            !!((_ctx.fullOrgList.length === 1 && _ctx.currentOrg)
            || (!_ctx.fullOrgList.length))
          
          }, {
            header: _withCtx(() => [
              _createVNode(_component_q_item_section, { avatar: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, {
                    icon: "factory",
                    "text-color": "text-primary"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, { overline: "" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  (!_ctx.orgProcessing)
                    ? (_openBlock(), _createBlock(_component_q_item_label, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.orgLabel), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_q_item_label, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_skeleton, {
                            type: "QInput",
                            bordered: "",
                            animation: "wave",
                            height: "16px",
                            width: "150px",
                            class: "bg-blue-grey-11"
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              (_ctx.fullOrgList.length)
                ? (_openBlock(), _createBlock(_component_SearchSelect, {
                    key: 0,
                    id: "step-1",
                    ref: "selectedOrgRef",
                    id_name: "N",
                    label: "Организация",
                    field: "org",
                    class: "q-my-xs",
                    options: _ctx.fullOrgList,
                    onSelect: _ctx.selectOrg,
                    onRemove: _ctx.removeOrg,
                    onFilter: _ctx.setSearchString
                  }, null, 8, ["options", "onSelect", "onRemove", "onFilter"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "label", "header-class", "disable"]),
          (_ctx.currentOrg)
            ? (_openBlock(), _createBlock(_component_q_expansion_item, {
                key: 0,
                modelValue: _ctx.data.expandedStructSelector,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.expandedStructSelector) = $event)),
                dense: "",
                "dense-toggle": "",
                "expand-separator": "",
                icon: "lan",
                label: "rere",
                "header-class": "text-primary"
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_avatar, {
                        icon: "lan",
                        "text-color": "text-primary"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, { overline: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.data.pinnedStaff ? 'Направление перемещения' : 'Штатная расстановка'), 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.data.pinnedStaff && !_ctx.structurePathLabel.departs)
                        ? (_openBlock(), _createBlock(_component_q_item_label, {
                            key: 0,
                            caption: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.structurePathLabel.departs)
                        ? (_openBlock(), _createBlock(_component_q_item_label, {
                            key: 1,
                            caption: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_badge, { class: "on-left" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, { name: "apartments" })
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.structurePathLabel.departs), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.structurePathLabel.post)
                        ? (_openBlock(), _createBlock(_component_q_item_label, {
                            key: 2,
                            caption: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_badge, { class: "on-left" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "group",
                                    class: "on-left"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.structurePathLabel.post.people_amount), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_badge, { class: "on-left" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "notification_important",
                                    class: "on-left"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.structurePathLabel.post.cnt_hazard), 1)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.structurePathLabel.post.title), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  (!_ctx.processing)
                    ? (_openBlock(), _createBlock(_component_q_list, {
                        key: 0,
                        id: "step-4",
                        bordered: "",
                        separator: "",
                        class: _normalizeClass(["list-borderless", {
              'q-mb-sm': _ctx.nodeProcessing,
            }])
                      }, {
                        default: _withCtx(() => [
                          (_ctx.data.pinnedStaff)
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: 0,
                                clickable: "",
                                class: _normalizeClass({
                pinnedItem: _ctx.data.pinnedStaff,
              }),
                                style: {"padding":"4px 8px 0 0"},
                                active: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, { avatar: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_avatar, { icon: "push_pin" })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, { overline: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" ФИО: " + _toDisplayString(_ctx.data.pinnedStaff?.fio), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_badge, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_icon, { name: "apartments" })
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" " + _toDisplayString(_ctx.data.pinnedStaff?.departament.replace('; ', ' / ')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_label, { caption: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_badge, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_icon, { name: "work" })
                                            ]),
                                            _: 1
                                          }),
                                          _createTextVNode(" " + _toDisplayString(_ctx.data.pinnedStaff?.post), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_item_section, { side: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        dense: "",
                                        round: "",
                                        push: "",
                                        icon: "close",
                                        "text-color": "primary",
                                        onClick: _withModifiers(_ctx.unpinStaff, ["stop"])
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"])), [
                                [_directive_ripple]
                              ])
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNodesMap, (nodeValue, index) => {
                            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                              clickable: "",
                              key: nodeValue.id_tree,
                              ref_for: true,
                              ref: _ctx.setItemRef,
                              class: "q-pa-none q-my-xs"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_SearchSelect, {
                                      id_name: "id_tree",
                                      field: "title",
                                      options: nodeValue.nodeEntries,
                                      valueVariant: 
                    _ctx.selectedNodesMap[index + 1]
                      ? _ctx.selectedNodesMap[index + 1].id_tree
                      : _ctx.treeNode
                    ,
                                      custom: true,
                                      autoshow: _ctx.data.autoshow,
                                      label: "Ветвь структуры или должность",
                                      onSelect: _ctx.select,
                                      onRemove: ($event: any) => (_ctx.removeNode(index)),
                                      onChangeType: _ctx.changeType,
                                      onFilter: _ctx.setSearchTreeString
                                    }, {
                                      "no-option": _withCtx(() => [
                                        _createVNode(_component_q_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                              default: _withCtx(() => [
                                                _hoisted_5
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      "selected-item": _withCtx((scope) => [
                                        _createVNode(_component_q_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_item_label, null, {
                                                  default: _withCtx(() => [
                                                    (scope.opt.id_type === 1)
                                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                                          key: 0,
                                                          color: "blue-4",
                                                          class: "q-mr-xs"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                              name: "apartments",
                                                              size: "xs"
                                                            })
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    (scope.opt.id_type === 2)
                                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                                          key: 1,
                                                          color: "cyan-8",
                                                          "text-color": "white",
                                                          class: "q-mr-xs"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                              name: "group",
                                                              size: "xs"
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(scope.opt.people_amount), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true),
                                                    (scope.opt.id_type === 2)
                                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                                          key: 2,
                                                          color: "amber-8",
                                                          "text-color": "white",
                                                          class: "q-mr-xs"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                              name: "notification_important",
                                                              size: "xs"
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(scope.opt.cnt_hazard), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(_toDisplayString(scope.opt.title), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      option: _withCtx((scope) => [
                                        _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_section, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_item_label, null, {
                                                  default: _withCtx(() => [
                                                    (scope.opt.id_type === 1)
                                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                                          key: 0,
                                                          color: "blue-4",
                                                          class: "q-mr-xs"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                              name: "apartments",
                                                              size: "xs"
                                                            })
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    (scope.opt.id_type === 2)
                                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                                          key: 1,
                                                          color: "cyan-8",
                                                          "text-color": "white",
                                                          class: "q-mr-xs"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                              name: "group",
                                                              size: "xs"
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(scope.opt.people_amount), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true),
                                                    (scope.opt.id_type === 2)
                                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                                          key: 2,
                                                          color: "amber-8",
                                                          "text-color": "white"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                              name: "notification_important",
                                                              size: "xs"
                                                            }),
                                                            _createTextVNode(" " + _toDisplayString(scope.opt.cnt_hazard), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true),
                                                    (
                              (scope.opt.id_type === 1 || !scope.opt.id_type)
                              && scope.opt.has_children
                            )
                                                      ? (_openBlock(), _createBlock(_component_q_badge, {
                                                          key: 3,
                                                          color: "indigo-4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                              name: "account_tree",
                                                              size: "xs"
                                                            })
                                                          ]),
                                                          _: 1
                                                        }))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" " + _toDisplayString(scope.opt.title), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1040)
                                      ]),
                                      _: 2
                                    }, 1032, ["options", "valueVariant", "autoshow", "onSelect", "onRemove", "onChangeType", "onFilter"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)), [
                              [_directive_ripple]
                            ])
                          }), 128)),
                          (_ctx.nodeProcessing)
                            ? (_openBlock(), _createBlock(_component_q_item, {
                                key: 1,
                                class: "q-pa-none"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_skeleton, {
                                        type: "QInput",
                                        bordered: "",
                                        animation: "wave",
                                        height: "40px",
                                        width: "100%",
                                        class: "bg-blue-grey-11"
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.data.tab === 'staff' && _ctx.selectedNodesMap.length && !_ctx.data.pinnedStaff)
        ? (_openBlock(), _createBlock(_component_q_input, {
            key: 0,
            outlined: "",
            debounce: "1000",
            class: "staff-search--input step-2",
            style: {"padding-left":"4px","padding-right":"4px"},
            modelValue: _ctx.data.staffSearch,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.staffSearch) = $event)),
            label: !_ctx.staffList.length ? 'Поиск сотрудника в организации по ФИО' : 'Поиск сотрудника',
            type: "search",
            dense: ""
          }, {
            append: _withCtx(() => [
              (
              _ctx.data.staffSearch !== '')
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "close",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.staffSearch = '')),
                    class: "cursor-pointer"
                  }))
                : _createCommentVNode("", true),
              (
                _ctx.data.staffSearch !== ""
                && (_ctx.data.typePost || !_ctx.staffList.length)
              )
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 1,
                    name: "travel_explore",
                    onClick: _ctx.globalSearch
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "label"]))
        : _createCommentVNode("", true),
      (_ctx.data.tab === 'patient' && !_ctx.data.pinnedStaff || (!_ctx.currentOrg && _ctx.userRang >= 100))
        ? (_openBlock(), _createBlock(_component_q_input, {
            key: 1,
            outlined: "",
            debounce: "1000",
            style: {"padding-left":"4px","padding-right":"4px"},
            class: "staff-search--input",
            modelValue: _ctx.patientSearch,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.patientSearch) = $event)),
            label: "Поиск пациента по ФИО или ID",
            type: "search",
            dense: ""
          }, _createSlots({
            append: _withCtx(() => [
              (
              _ctx.patientSearch !== '')
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "close",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.patientSearch = '')),
                    class: "cursor-pointer"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (_ctx.currentOrg)
              ? {
                  name: "after",
                  fn: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      round: "",
                      dense: "",
                      flat: "",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.data.showContractFilter = !_ctx.data.showContractFilter)),
                      icon: _ctx.data.showContractFilter ? 'filter_alt_off' : 'filter_alt_'
                    }, null, 8, ["icon"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.data.showContractFilter && _ctx.data.tab === 'patient')
        ? (_openBlock(), _createBlock(_component_q_select, {
            key: 2,
            outlined: "",
            dense: "",
            behavior: "menu",
            "use-input": _ctx.data.inputMode,
            ref: "contractSelect",
            class: "q-my-xs",
            style: {"padding-left":"4px","padding-right":"4px"},
            modelValue: _ctx.data.selectedContract,
            "onUpdate:modelValue": [
              _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.selectedContract) = $event)),
              _ctx.selectContract
            ],
            options: _ctx.filteredContracts,
            label: "Фильтр по договору",
            onFilter: _ctx.onContractsFilter,
            onPopupShow: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleInputMode(true))),
            onPopupHide: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleInputMode(false)))
          }, _createSlots({
            selected: _withCtx(() => [
              (_ctx.data.selectedContract)
                ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                    _createVNode(_component_q_badge, {
                      class: "q-py-xs q-mr-sm",
                      color: "indigo-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" ID " + _toDisplayString(_ctx.data.selectedContract.id_contract), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.data.selectedContract.N_contract)
                      ? (_openBlock(), _createBlock(_component_q_badge, {
                          key: 0,
                          class: "",
                          size: "sm",
                          color: _ctx.recContractColor(_ctx.data.selectedContract)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: "bookmark",
                              size: "xs",
                              class: "on-left"
                            }),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.data.selectedContract.N_contract), 1)
                          ]),
                          _: 1
                        }, 8, ["color"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            option: _withCtx((scope) => [
              _createVNode(_component_q_item, _mergeProps(scope.itemProps, {
                dense: "",
                class: "q-py-xs",
                style: {"border-bottom":"1px solid #c2c2c2"}
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, { class: "row items-start q-gutter-y-xs" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_badge, {
                            class: "q-py-xs q-mr-sm",
                            color: "indigo-4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" ID " + _toDisplayString(scope.opt.id_contract), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (scope.opt.N_contract)
                            ? (_openBlock(), _createBlock(_component_q_badge, {
                                key: 0,
                                class: "q-mr-sm text-wrap",
                                size: "sm",
                                color: _ctx.recContractColor(scope.opt)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "bookmark",
                                    size: "xs",
                                    class: "on-left"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(scope.opt.N_contract), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]))
                            : _createCommentVNode("", true),
                          (scope.opt.date_contract)
                            ? (_openBlock(), _createBlock(_component_q_badge, {
                                key: 1,
                                color: "blue-grey-6 q-mr-sm"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "today",
                                    size: "xs",
                                    class: "on-left"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(scope.opt.date_contract), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_label, { caption: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.opt.name_contract), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1040)
            ]),
            append: _withCtx(() => [
              (_ctx.data.selectedContract)
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: "close",
                    onClick: _withModifiers(_ctx.removeContract, ["stop","prevent"]),
                    class: "cursor-pointer"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (
              _ctx.data.selectedContract
              && _ctx.data.selectedContract.id_contract
              && _ctx.userRang >= 100
            )
              ? {
                  name: "after",
                  fn: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.data.showContractSummery = true;}),
                      round: "",
                      dense: "",
                      flat: "",
                      icon: "announcement"
                    })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["use-input", "modelValue", "options", "onFilter", "onUpdate:modelValue"]))
        : _createCommentVNode("", true),
      ((_ctx.currentOrg || _ctx.actualPatients.length) && !_ctx.data.pinnedStaff)
        ? (_openBlock(), _createBlock(_component_q_tabs, {
            key: 3,
            modelValue: _ctx.data.tab,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.tab) = $event)),
            dense: "",
            "inline-label": "",
            class: "text-blue-grey-4"
          }, {
            default: _withCtx(() => [
              (_ctx.currentOrg)
                ? (_openBlock(), _createBlock(_component_q_tab, {
                    key: 0,
                    name: "staff",
                    icon: "engineering"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_tab, {
                name: "patient",
                icon: "personal_injury"
              }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createVNode(_component_q_badge, {
                    color: "cyan-8",
                    class: "q-ml-sm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "group",
                        size: "xs"
                      }),
                      (_ctx.actualPatientsLength !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.actualPatientsLength), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createVNode(_component_q_spinner_hourglass)
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ], 512),
    (_ctx.data.tab === 'staff')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "staffTab",
          style: _normalizeStyle({'max-height': _ctx.data.listStyle.height})
        }, [
          (_ctx.staffList.length && !_ctx.data.pinnedStaff)
            ? (_openBlock(), _createBlock(_component_q_pull_to_refresh, {
                key: 0,
                "scroll-target": _ctx.patientTab,
                onRefresh: _ctx.refreshStaffs,
                color: "teal"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_virtual_scroll, {
                    id: _ctx.data.typePost ? '': 'step-3',
                    class: "tree-staff-list",
                    items: _ctx.filteredStaffList,
                    "virtual-scroll-item-size": "55",
                    onVirtualScroll: _ctx.checkOpenedOptions
                  }, {
                    default: _withCtx(({ item, index }) => [
                      (_openBlock(), _createBlock(_component_SlideOption, {
                        id: "step-7",
                        ref: el => { _ctx.staffSlideItem[index] = el },
                        key: index,
                        onAction: _ctx.defineStaffAction,
                        onSetValue: _ctx.resetStaffSlide,
                        onSelectItem: _ctx.findTreepathToStaff,
                        item: item,
                        index: index,
                        optionsLeft: [
                  {
                    color: `bg-light-green-8 text-white ${_ctx.data.typePost ? '' : 'hidden'}`,
                    icon: 'add',
                    action: 'addPatient',
                    label: 'Пациент',
                  },
                  {
                    color: 'bg-light-blue-8 text-white',
                    icon: 'rotate_right',
                    action: 'showVisits',
                    label: 'Визиты',
                    additional: item.amount_vizits
                  },
                  {
                    color: 'bg-cyan-4 text-white',
                    icon: 'alternate_email',
                    action: 'showContacts',
                    label: 'Контакты',
                  },
                ],
                        optionsRight: [
                  {
                    color: 'bg-red-10  text-white',
                    icon: 'person_remove',
                    action: 'removeStaff',
                    label: 'Уволен',
                  },
                  {
                    color: 'bg-orange-4 text-white',
                    icon: 'move_up',
                    action: 'pinStaff',
                    label: 'Переместить',
                  },
                  {
                    color: 'bg-indigo-6 text-white',
                    icon: 'manage_accounts',
                    action: 'showEditStaffModal',
                    label: 'Изменить',
                  },
                ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  (!_ctx.data.typePost)
                                    ? (_openBlock(), _createBlock(_component_q_item_label, {
                                        key: 0,
                                        overline: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_badge, {
                                            color: "secondary",
                                            "text-color": "light",
                                            class: "q-mr-sm post-badge column",
                                            style: {"align-items":"flex-start"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, [
                                                _createVNode(_component_q_icon, {
                                                  name: "account_tree",
                                                  class: "q-mr-xs"
                                                }),
                                                _createTextVNode(" " + _toDisplayString(item.departament), 1)
                                              ]),
                                              _createElementVNode("span", null, [
                                                _createVNode(_component_q_icon, {
                                                  name: "work",
                                                  class: "q-mr-xs"
                                                }),
                                                _createTextVNode(" " + _toDisplayString(item.post), 1)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_q_item_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.fio), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_item_label, {
                                    caption: "",
                                    class: "row"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_badge, {
                                        class: "q-mr-xs",
                                        color: 
                          item.sex === 'м' ? 'blue-2'
                            : item.sex === 'ж' ? 'purple-2'
                            : 'grey-4',
                                        "text-color": "dark"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.sex), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]),
                                      _createVNode(_component_q_badge, {
                                        color: "blue-grey-2",
                                        "text-color": "black"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            name: "event",
                                            class: "q-mr-xs"
                                          }),
                                          _createTextVNode(" " + _toDisplayString(item.datebirth), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_section, {
                                side: "",
                                top: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, { caption: "" }, {
                                    default: _withCtx(() => [
                                      (item.id_patient && item.id_patient.length)
                                        ? (_openBlock(), _createElementBlock("b", _hoisted_12, _toDisplayString(item.id_patient[0].status), 1))
                                        : (_openBlock(), _createElementBlock("b", _hoisted_13, "-/-"))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_item_label, { caption: "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_badge, { color: "blue-4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_icon, {
                                            name: "rotate_right",
                                            class: "q-mr-xs"
                                          }),
                                          _createTextVNode(" " + _toDisplayString(item.amount_vizits), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onAction", "onSetValue", "onSelectItem", "item", "index", "optionsLeft"]))
                    ]),
                    _: 1
                  }, 8, ["id", "items", "onVirtualScroll"])
                ]),
                _: 1
              }, 8, ["scroll-target", "onRefresh"]))
            : _createCommentVNode("", true),
          (!_ctx.staffList.length && !_ctx.data.pinnedStaff)
            ? (_openBlock(), _createBlock(_component_q_list, {
                key: 1,
                class: "q-mt-md q-px-none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, {
                        avatar: "",
                        class: "items-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "emoji_people",
                            size: "md",
                            color: "primary"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, { class: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _hoisted_14,
                              _hoisted_15,
                              _hoisted_16,
                              _hoisted_17,
                              _hoisted_18,
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, {
                        avatar: "",
                        class: "items-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "rule",
                            size: "md",
                            color: "primary"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, { class: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _hoisted_20,
                              _hoisted_21
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.data.tab === 'patient')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref: "patientTab",
          style: _normalizeStyle({'max-height': _ctx.data.listStyle.height, 'overflow': 'scroll'})
        }, [
          _createVNode(_component_q_pull_to_refresh, {
            "scroll-target": _ctx.patientTab,
            onRefresh: _ctx.refreshPatients,
            color: "teal"
          }, {
            default: _withCtx(() => [
              (_ctx.actualPatients.length && !_ctx.data.pinnedStaff)
                ? (_openBlock(), _createBlock(_component_q_infinite_scroll, {
                    key: 0,
                    class: "tree-staff-list",
                    ref: "infinityPatients",
                    disable: !!(_ctx.actualPatientsLength && _ctx.actualPatientsLength <= _ctx.pagin.p_start),
                    "scroll-target": _ctx.patientTab,
                    onLoad: _ctx.onPatientsLoad,
                    offset: 100
                  }, {
                    loading: _withCtx(() => [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_q_spinner_dots, {
                          color: "primary",
                          size: "40px"
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_q_virtual_scroll, {
                        items: _ctx.filteredPatientList,
                        "virtual-scroll-item-size": "73",
                        offset: 100,
                        onVirtualScroll: _ctx.checkOpenedOptions
                      }, {
                        default: _withCtx(({ item, index }) => [
                          (_openBlock(), _createBlock(_component_SlideOption, {
                            ref: el => { _ctx.patientSlideItem[index] = el },
                            onAction: _ctx.definePatientAction,
                            onSetValue: _ctx.resetPatientSlide,
                            item: item,
                            index: index,
                            key: index,
                            optionsLeft: [
                    {
                      color:
                        `bg-light-green-8 text-white ${item.status === 'Черновик' ? '' : 'hidden'}`,
                      icon: 'file_open',
                      action: 'continuePatient',
                      label: 'Продолжить',
                    },
                    {
                      color: `
                        bg-light-green-8 text-white ${item.status === 'В ожидании' ? '' : 'hidden'}
                      `,
                      icon: 'edit_note',
                      action: 'editPatient',
                      label: 'Править',
                    },
                    {
                      color:
                        `bg-indigo-4 text-white`,
                      icon: 'account_tree',
                      action: 'findStaff',
                      label: 'К сотруднику',
                    },
                  ],
                            optionsRight: [
                    {
                      color:
                        `bg-orange-10 text-white ${item.status === 'В ожидании' ? '' : 'hidden'}`,
                      icon: 'block',
                      action: 'cancelPatient',
                      label: 'Отменить',
                    },
                    {
                      color: `bg-red-10 text-white ${item.status === 'Черновик' ? '' : 'hidden'}`,
                      icon: 'delete',
                      action: 'removePatient',
                      label: 'Удалить',
                    },
                    {
                      color: `
                        bg-brown-6
                        text-white
                        ${item.status !== 'Черновик' && _ctx.userRang >= 100 ? '' : 'hidden'}
                      `,
                      icon: 'connect_without_contact',
                      action: 'nastuchat',
                      label: 'Настучать',
                    },
                  ]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(item.fio), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_q_item_label, {
                                        caption: "",
                                        class: "column items-start"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("section", _hoisted_22, [
                                            _createVNode(_component_q_badge, {
                                              color: "indigo-2",
                                              "text-color": "black",
                                              class: "on-left"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" ID " + _toDisplayString(item.id_patient), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_q_badge, {
                                              color: "blue-grey-2",
                                              "text-color": "black",
                                              class: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_icon, {
                                                  name: "event",
                                                  class: "q-mr-xs"
                                                }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.date.formatDate(item.date_add, 'DD.MM.YYYY')) + " ", 1),
                                                _createVNode(_component_q_icon, {
                                                  name: "schedule",
                                                  class: "q-mx-xs"
                                                }),
                                                _createTextVNode(" " + _toDisplayString(_ctx.date.formatDate(item.date_add.slice(0, -1), 'HH:mm')), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          (JSON.parse(item.lmk_status).length)
                                            ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                                                _createVNode(_component_q_badge, {
                                                  class: "column",
                                                  style: {"align-items":"flex-start"},
                                                  color: 
                              JSON.parse(item.lmk_status)[0].lmk_status.includes('Выдано')
                              ? 'green-4'
                            : JSON.parse(item.lmk_status)[0].lmk_status.includes('Зарегистрировано')
                              ? 'deep-orange-4' : ''
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, "ЛМК: " + _toDisplayString(JSON.parse(item.lmk_status)[0].lmk_status), 1),
                                                    (JSON.parse(item.lmk_status)[0].lmk_took_date)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Создана: " + _toDisplayString(JSON.parse(item.lmk_status)[0].lmk_took_date), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["color"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_item_section, {
                                    side: "",
                                    class: "side-wrapper"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, {
                                        caption: "",
                                        class: "side-status"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("b", null, [
                                            _createVNode(_component_q_icon, {
                                              name: "info",
                                              color: "secondary",
                                              size: "xs",
                                              class: "on-left"
                                            }),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(item.status === 'Отменен' ? 'text-negative' : '')
                                            }, _toDisplayString(item.status), 3),
                                            _createVNode(_component_q_popup_proxy, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_banner, { class: "patient-info text-center" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_list, { class: "personal-info" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_q_item, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                              name: "info",
                                                              color: "secondary",
                                                              class: "info-avatar"
                                                            })
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createVNode(_component_q_item, { dense: "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_25
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.fio), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_item, { dense: "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_26
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.birthdate), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_item, { dense: "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_27
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.sex), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_item, {
                                                          dense: "",
                                                          class: "q-pb-sm"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_28
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_q_btn, {
                                                                      dense: "",
                                                                      flat: "",
                                                                      color: "indigo-4",
                                                                      icon: "account_tree",
                                                                      "no-caps": "",
                                                                      label: `${item.unit_name} / ${item.post_name}`,
                                                                      onClick: ($event: any) => (_ctx.findStaffByPatient(item))
                                                                    }, null, 8, ["label", "onClick"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_item, {
                                                          dense: "",
                                                          class: "q-pb-sm"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_29
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.date_vizit), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_item, {
                                                          dense: "",
                                                          class: "q-pb-sm"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_30
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.status), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode("(" + _toDisplayString(item.status_describe) + ")", 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_list, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_q_item, {
                                                          dense: "",
                                                          class: "q-pt-sm"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_31
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.name_contract), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_item, { dense: "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_32
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.type_contract), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_item, { dense: "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_33
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.type_osmotr), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_q_item, { dense: "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_item_section, null, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_q_item_label, { overline: "" }, {
                                                                  default: _withCtx(() => [
                                                                    _hoisted_34
                                                                  ]),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_q_item_label, null, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.payment_type_text), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    (item.status === 'Черновик')
                                                      ? (_openBlock(), _createBlock(_component_q_btn_group, {
                                                          key: 0,
                                                          spread: "",
                                                          class: "q-mx-sm q-mt-sm"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_q_btn, {
                                                              color: "light-green-8",
                                                              icon: "file_open",
                                                              onClick: _withModifiers(($event: any) => (_ctx.continuePatient(item)), ["stop"])
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _hoisted_35
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"]),
                                                            _createVNode(_component_q_btn, {
                                                              color: "red-10",
                                                              icon: "delete",
                                                              onClick: _withModifiers(($event: any) => (_ctx.removePatient(item)), ["stop"])
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _hoisted_36
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"])
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_q_item_label, {
                                        caption: "",
                                        class: "side-status"
                                      }, {
                                        default: _withCtx(() => [
                                          (item.n_docs || item.docs_in_progress)
                                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                                key: 0,
                                                push: "",
                                                color: "white",
                                                "text-color": "secondary",
                                                icon: "description",
                                                class: "q-px-sm patient-documents-btn",
                                                size: "sm",
                                                onClick: ($event: any) => (_ctx.getDocuments(item.id_patient, item))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("div", null, [
                                                    _createElementVNode("p", _hoisted_37, [
                                                      _hoisted_38,
                                                      _createElementVNode("b", null, _toDisplayString(item.n_docs ? item.n_docs : '-/-'), 1)
                                                    ]),
                                                    _createElementVNode("p", _hoisted_39, [
                                                      (item.docs_in_progress)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                                            _hoisted_41,
                                                            _createElementVNode("b", null, _toDisplayString(item.docs_in_progress), 1),
                                                            _createVNode(_component_q_spinner_gears, { color: "teal" })
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ]),
                                                  _createVNode(_component_q_menu, { class: "patient-doc-menu" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.patientDocList)
                                                        ? (_openBlock(), _createBlock(_component_q_list, { key: 0 }, {
                                                            default: _withCtx(() => [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientDocList, (doc) => {
                                                                return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                                                  key: doc.id_document,
                                                                  class: _normalizeClass({
                                  'ready': !doc.docs_in_progress,
                                  'c': doc.docs_in_progress,
                                })
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_q_item_section, null, {
                                                                      default: _withCtx(() => [
                                                                        _createElementVNode("div", _hoisted_42, [
                                                                          _createElementVNode("span", _hoisted_43, [
                                                                            _createVNode(_component_q_item_label, null, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(doc.doc_name.replaceAll('_', ' ')), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024),
                                                                            _createVNode(_component_q_item_label, { caption: "" }, {
                                                                              default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(doc.date_document), 1)
                                                                              ]),
                                                                              _: 2
                                                                            }, 1024)
                                                                          ])
                                                                        ])
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024),
                                                                    _createVNode(_component_q_item_section, { side: "" }, {
                                                                      default: _withCtx(() => [
                                                                        _createElementVNode("span", null, [
                                                                          _createVNode(_component_q_badge, {
                                                                            class: "q-mr-sm",
                                                                            color: "primary",
                                                                            onClick: ($event: any) => (_ctx.showContacts(doc))
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_q_icon, {
                                                                                name: "attach_email",
                                                                                color: "white"
                                                                              })
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["onClick"]),
                                                                          _createVNode(_component_q_badge, {
                                                                            class: "q-mr-sm",
                                                                            color: "primary",
                                                                            onClick: ($event: any) => (_ctx.docDownload(doc))
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_q_icon, {
                                                                                name: "download",
                                                                                color: "white"
                                                                              })
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["onClick"]),
                                                                          _createVNode(_component_q_badge, {
                                                                            color: "primary",
                                                                            onClick: ($event: any) => (_ctx.docPreview(doc.id_document))
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createVNode(_component_q_icon, {
                                                                                name: "preview",
                                                                                color: "white"
                                                                              })
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["onClick"])
                                                                        ])
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["class"])), [
                                                                  [_directive_close_popup]
                                                                ])
                                                              }), 128))
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : (_openBlock(), _createBlock(_component_AppLoader, { key: 1 }))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onAction", "onSetValue", "item", "index", "optionsLeft", "optionsRight"]))
                        ]),
                        _: 1
                      }, 8, ["items", "onVirtualScroll"])
                    ]),
                    _: 1
                  }, 8, ["disable", "scroll-target", "onLoad"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["scroll-target", "onRefresh"])
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      class: "draft-dialog",
      modelValue: _ctx.data.showDraft,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data.showDraft) = $event)),
      persistent: "",
      "transition-show": "scale",
      "transition-hide": "scale"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-teal text-white draft-wrapper" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_45
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none draft-wrapper" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, { class: "q-my-sm" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.draft, (item) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        bordered: "",
                        separator: "",
                        class: "draft-item",
                        key: item.id_patient
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { style: {"min-width":"235px"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, {
                                caption: "",
                                class: "column items-start"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("section", null, [
                                    _createVNode(_component_q_badge, {
                                      color: "indigo-2",
                                      "text-color": "black"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" ID " + _toDisplayString(item.id_patient), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_q_badge, {
                                      class: "q-mx-xs",
                                      color: "blue-2",
                                      "text-color": "dark"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          name: "person_add",
                                          class: "q-mr-xs"
                                        }),
                                        _createElementVNode("span", _hoisted_46, _toDisplayString(item.fio_add), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _createVNode(_component_q_badge, {
                                    color: "blue-grey-2",
                                    "text-color": "black",
                                    class: "q-mt-xs"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        name: "event",
                                        class: "q-mr-xs"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.date.formatDate(item.date_add, 'DD.MM.YYYY')) + " ", 1),
                                      _createVNode(_component_q_icon, {
                                        name: "schedule",
                                        class: "q-mx-xs"
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.date.formatDate(item.date_add.slice(0, -1), 'HH:mm')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, {
                                caption: "",
                                center: "",
                                class: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_btn_group, {
                                    dense: "",
                                    push: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_btn, {
                                        dense: "",
                                        color: "light-green-8",
                                        icon: "file_open",
                                        size: "sm",
                                        onClick: _withModifiers(($event: any) => (_ctx.continuePatient(item)), ["stop","prevent"])
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_47
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_q_btn, {
                                        style: {"min-width":"40px"},
                                        dense: "",
                                        size: "sm",
                                        color: "red-10",
                                        icon: "delete",
                                        onClick: _withModifiers(($event: any) => (_ctx.removePatient(item)), ["stop","prevent"])
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "bg-white text-teal"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  dense: "",
                  push: "",
                  label: "Создать нового",
                  onClick: _ctx.addPatientForce,
                  icon: "add",
                  size: "sm"
                }, null, 8, ["onClick"]),
                _withDirectives(_createVNode(_component_q_btn, {
                  dense: "",
                  flat: "",
                  label: "Отмена",
                  icon: "close",
                  size: "sm"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.data.tab === 'staff')
      ? (_openBlock(), _createBlock(_component_q_dialog, {
          key: 2,
          modelValue: _ctx.nodeActions,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.nodeActions) = $event)),
          seamless: "",
          "full-width": "",
          position: "bottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn_group, { spread: "" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.actionButtons, (button, index) => {
                          return (_openBlock(), _createBlock(_component_AppButton, _mergeProps({
                            id: button.id,
                            key: index
                          }, button, {
                            label: button.label,
                            icon: button.icon
                          }), null, 16, ["id", "label", "icon"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.staffActions,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.staffActions) = $event)),
      seamless: "",
      "full-width": "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn_group, { spread: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      push: "",
                      color: "white",
                      "text-color": "accent",
                      icon: "manage_accounts",
                      class: "q-mr-sm",
                      onClick: _withModifiers(_ctx.moveStaff, ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_48
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_q_btn, {
                      push: "",
                      color: "white",
                      "text-color": "accent",
                      icon: "group_add",
                      class: "q-mr-sm",
                      onClick: _withModifiers(_ctx.copyStaff, ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _hoisted_49
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.data.checkDirection,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.data.checkDirection) = $event)),
      seamless: "",
      "full-width": "",
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "warning-notify" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center text-center no-wrap justify-center" }, {
              default: _withCtx(() => [
                _hoisted_50
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.data.showContractSummery,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.data.showContractSummery) = $event)),
      "transition-show": "scale",
      "transition-hide": "scale"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "bg-teal text-white",
          style: {"width":"300px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_51
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_section, {
              style: {"max-height":"50vh"},
              class: "scroll q-pa-sm"
            }, {
              default: _withCtx(() => [
                _hoisted_52,
                _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.data.selectedContract.note_for_adm ? _ctx.data.selectedContract.note_for_adm : '-/-'), 1),
                _hoisted_54,
                _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.data.selectedContract.type_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "bg-white text-teal"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "Закрыть"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.data.selectedPatient)
      ? (_openBlock(), _createBlock(_component_q_dialog, {
          key: 3,
          modelValue: _ctx.data.showStuchalka,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.data.showStuchalka) = $event)),
          "transition-show": "scale",
          "transition-hide": "scale"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, {
              class: "bg-brown-6 text-white",
              style: {"width":"350px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.data.selectedPatient.fio), 1),
                      _createElementVNode("span", _hoisted_59, [
                        _hoisted_60,
                        _createElementVNode("span", {
                          class: _normalizeClass({
                      'text-red-13': _ctx.data.selectedStatusBar?.balance < 0,
                    })
                        }, _toDisplayString(_ctx.data.selectedStatusBar?.balance ?? '-/-'), 3),
                        _createVNode(_component_q_icon, {
                          color: "white",
                          name: "currency_ruble",
                          style: {"font-size":"12px"}
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_section, {
                  style: {"min-height":"150px","max-height":"50vh"},
                  class: "scroll stuchalka"
                }, {
                  default: _withCtx(() => [
                    (_ctx.data.selectedStatusBar?.nastuchat)
                      ? (_openBlock(), _createBlock(_component_q_list, {
                          key: 0,
                          separator: "",
                          style: {"max-height":"250px"},
                          class: "scroll q-my-md"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.selectedStatusBar.nastuchat.split(';'), (item, index) => {
                              return (_openBlock(), _createBlock(_component_q_item, {
                                dense: "",
                                key: index
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.data.textStuchalka,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.data.textStuchalka) = $event)),
                      filled: "",
                      autogrow: "",
                      color: "white",
                      placeholder: "Что стоит знать о пациенте?",
                      hint: "Предупредим коллег",
                      "label-color": "white"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_q_checkbox, {
                      color: "white",
                      "keep-color": "",
                      "right-label": "",
                      modelValue: _ctx.data.adminNotify,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.data.adminNotify) = $event)),
                      label: "Старшему администратору на почту",
                      "checked-icon": "task_alt",
                      "unchecked-icon": "highlight_off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_actions, {
                  align: "right",
                  class: "bg-white text-primary"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      flat: "",
                      label: "Закрыть"
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _createVNode(_component_q_btn, {
                      disabled: !_ctx.data.textStuchalka,
                      push: "",
                      label: "Отправить",
                      color: "brown-6",
                      "text-color": "white",
                      onClick: _ctx.sendReport
                    }, null, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}